import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {APIClientService} from "../../../common/services/apiclient.service";
import {Field} from "../../../common/enums/Field";
import {ValidationErrorType} from "../../../common/enums/ValidationErrorType";
import {CustomerApi} from "../../../common/apis/customer-api";

@Component({
  selector: 'app-subscribe-email',
  templateUrl: './subscribe-email.component.html',
  styleUrls: ['./subscribe-email.component.css']
})
export class SubscribeEmailComponent {
  subscriptionForm: FormGroup;
  showEmailError: boolean = false;

  emailServerError: string | null = null
  formSuccessMessage: string | null = null
  loadingSubscriptionForm: boolean = false

  constructor(
    private formBuilder: FormBuilder,
    private backendApiClientService: APIClientService,
    private customerApi: CustomerApi
  ) {
  }

  ngOnInit() {
    this.subscriptionForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, Validators.maxLength(320)]]
    });

    this.listenToEmailChanges();
  }

  registerEmail() {
    console.log("Login form submitted.");
    const email = this.subscriptionForm.get("email");
    console.log(this.subscriptionForm);
    console.log("email = " + email);

    if (email && email.valid) {
      this.showEmailError = false;
      console.log("showEmailError = false");

      this.loadingSubscriptionForm = true
      this.disableFormFields()
      // TODO: Submit the email to the backend.
      this.customerApi.subscribeCustomerEmail(email.value).subscribe({
          next: (response) => {
            this.enableFormFields()
            console.log(response);
            // this.options = response;
            console.log("response = " + response);
            this.resetMessages()
            this.formSuccessMessage = $localize`Thank you for submitting your email. Please check your email for a subscription confirmation email.`
            this.loadingSubscriptionForm = false
          }
          ,
          error: (error) => {
            this.enableFormFields()
            this.resetMessages()
            if (Array.isArray(error)) {
              // Handle each error separately
              error.map(singleError => {
                console.log(singleError.errorType)
                console.log(singleError.field)
                if (singleError.field == Field.EMAIL) {
                  if (singleError.errorType == ValidationErrorType.DUPLICATE) {
                    this.showEmailError = true;
                    console.log(this.showEmailError)
                    this.emailServerError = $localize`This email is already registered.`
                  }
                }
              });
            } else {
              console.log("error is NOT an array")
              //TODO: Check if type of error is string before printing
              this.showEmailError = true
              this.emailServerError = error
              // Handle a single error
              // [this.processError(error)];
            }

            if (this.emailServerError == null) {
              this.emailServerError = $localize`An unknown error has occurred. Please try again later or contact support.`
            }
            this.loadingSubscriptionForm = false
          }
        }
      )
    } else {
      this.showEmailError = true;
      console.log("showEmailError = true");
    }
  }

  listenToEmailChanges() {
    this.subscriptionForm.get('email')?.valueChanges.subscribe(() => {
      // Hide the error message here
      // For example, you can set some flag to false which is used to control the visibility of the error message
      this.resetMessages()
    });
  }


  get email() {
    return this.subscriptionForm.get('email');
  }

  private resetMessages() {
    this.showEmailError = false
    this.formSuccessMessage = null
    this.emailServerError = null
  }

  private disableFormFields() {
    this.subscriptionForm.get('email')?.disable()
  }

  private enableFormFields() {
    this.subscriptionForm.get('email')?.enable()
  }
}
